import type * as TooltipPrimitive from "@radix-ui/react-tooltip";
import type {
  ComponentPropsWithoutRef,
  ComponentRef,
  PropsWithChildren,
} from "react";

/*-------------------------------------
|  Constants
-------------------------------------*/

export const TOOLTIP_SIDES = [ "top", "bottom", "left", "right" ] as const;

export const TOOLTIP_CONTENT_CLASS = "bg-component-tooltip-surface text-foreground-inverse";

export const TOOLTIP_ARROW_CLASS = "fill-sys-black-850";

export const TOOLTIP_SHORTCUT_CLASS = [
  "inline-flex min-w-4 items-center justify-center px-1",
  "rounded-sys-sm bg-component-tooltip-shortcut",
  "font-sys-default text-sys-xs leading-sys-1-3 text-foreground-inverse",
].join(" ");

export const TOOLTIP_DELAY_DURATION = 200;

export const TOOLTIP_SIDE_OFFSET = 6;

/*-------------------------------------
|  Types
-------------------------------------*/

export type TTooltipSide = (typeof TOOLTIP_SIDES)[number];

export type TTooltipProps = ComponentPropsWithoutRef<typeof TooltipPrimitive.Root>;

export type TTooltipTriggerElement = ComponentRef<typeof TooltipPrimitive.Trigger>;
export type TTooltipTriggerProps = ComponentPropsWithoutRef<typeof TooltipPrimitive.Trigger>;

export type TTooltipContentElement = ComponentRef<typeof TooltipPrimitive.Content>;
export type TTooltipContentProps = ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>;

export type TTooltipShortcutProps = PropsWithChildren & {
  className?: string;
};
